import React from "react"

// import reactIcon from "../assets/reactjs-icon.png"

import { Link } from "react-router-dom";

export default function Navbar()
{
    return (

            <nav className="navbarMain" id="Home">
                {/* <img src={reactIcon}/> */}

                <a href = "#about" className="headingName">

                <h3 className="headingName">
                    Home
                </h3>

                </a>

                <a href = "#about">

                <h4>
                    About
                </h4>

                </a>

                <a href = "#projects">
                <h4>
                    Projects
                </h4>
                </a>

                <a href = "#skills">
                <h4>
                    Skills
                </h4>
                </a>


                <a href = "#contacts">
                    <h4>
                        Contact
                    </h4>
                </a>

                
                <a href = "https://drive.google.com/file/d/1Ozyg_TxmrVevA4LsoWKF6_jcYTy1tLNY/view?usp=drive_link" target="_blank">
                    <h4>
                        Resume
                    </h4>
                </a>

            </nav>

    )
}



export function Navbar2()
{
    return (

            <nav className="navbarMain" id="Home">

                <Link to="/">

                <h3 className="headingName">
                    Home
                </h3>

                </Link>

            </nav>

    )
}